<template>
    <div class="course-card pb-0">
        <div class="row">
            <div class="col-12 col-lg-2 order-lg-1 order-2 d-lg-flex d-none">
                <router-link :to="{ name: 'Exam', params: { id: result.idexam }}">
                    <img
                            class="rounded img-fluid"
                            v-if="result.exam.logo"
                            :src="result.exam.logo"
                    >

                    <img
                            class="rounded img-fluid"
                            src="@/assets/hometeacher/images/home-kurs-none.png"
                            v-else
                    >
                </router-link>
            </div>

            <div class="col-12 col-lg-10 order-lg-2 order-1">
                <div class="row align-items-center mb-3">
                    <div class="col order-lg-1">
                        <router-link
                                class="course-card-title h1"
                                :to="{ name: 'Exam', params: { id: result.idexam }}"
                        >
                            {{ result.exam.exam }}
                        </router-link>
                    </div>

                    <div class="col-auto order-lg-2 d-lg-flex d-none">
                        <router-link
                                class="select-course-btn"
                                :to="{ name: 'courses' }"
                        >
                            {{ $t('select_course') }}
                        </router-link>
                    </div>
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-sm-4">
                        <ul class="statistic">
                            <li class="statistic__item">
                                <BaseProgress
                                        :height="10"
                                        :show-percentage="false"
                                        :value="pointsPercent"
                                >
                                    <template v-slot:label>
                                        {{ $t('points_achieved') }}:
                                        <strong>
                                            {{ result.points }} {{ $t('from') }} {{ result.exam.maxPoints }}
                                        </strong>
                                    </template>
                                </BaseProgress>
                            </li>

                            <li class="statistic__item mt--3">
                                {{ $t('errors_count') }}: <strong> {{ result.errors }} </strong>
                            </li>
                        </ul>

                    </div>
                    <div class="col-12 d-flex d-lg-none mt-4 mb-4">
                        <router-link :to="{ name: 'Exam', params: { id: result.idexam }}">
                            <img
                                    class="rounded img-fluid"
                                    v-if="result.exam.logo"
                                    :src="result.exam.logo"
                            >

                            <img
                                    class="rounded img-fluid"
                                    src="@/assets/hometeacher/images/home-kurs-none.png"
                                    v-else
                            >
                        </router-link>
                    </div>
                    <div class="col-sm-8">
                        <div class="col-sm-12 course-result__description px-0">
                            {{ stripHtml(result.examResult.exam_result) }}
                            <router-link class="d-lg-inline d-inline-block course-card__repeate"
                                         :to="{ name: 'Exam', params: { id: result.idexam }}">
                                {{ $t('repeat_test') }}
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 d-flex d-lg-none mt-4 mb-4">
                        <router-link
                                class="select-course-btn"
                                :to="{ name: 'courses' }"
                        >
                            {{ $t('select_course') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div><!-- /.row -->
        <div class="row share-wrapper mt-4 d-lg-flex d-none">
            <div class="col-12 text-right d-flex justify-content-end  my-2">
                <div class="mt-2 mr-3 share-label">{{ $t('share_result') }}:</div>

                <Share
                        class="ml-3"
                        :title="$t('share_text')"
                        :url="$t('share_url')"
                        :hashtags="$t('share_tags')"
                        :hideTitle="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import BaseProgress from '@/components/BaseProgress';
    import Share from "./../../Share";

    export default {
        name: 'ExamCard',
        components: {
            BaseProgress,
            Share
        },
        props: {
            result: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                expanded: false,
                activated: false,
            }
        },
        computed: {
            pointsPercent() {
                return Math.round(100 / this.result.exam.maxPoints * this.result.points);
            },

            language() {
                return '';
            },

            difficlty() {
                return 'easy';
            },
        },

        methods: {
            stripHtml(html) {
                // Create a new div element
                var temporalDivElement = document.createElement("div");
                // Set the HTML content with the providen
                temporalDivElement.innerHTML = html;
                // Retrieve the text property of the element (cross-browser support)
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            }
        },

    }
</script>

<style scoped>
    .share-label {
        color: #4f4d5c;
        font-size: 15px;
    }

    .share-wrapper {
        background-color: #e6eff2;
        margin-right: -20px;
        margin-left: -20px;
    }

    .dop-pack-expand {
        font-size: 14px;
        color: #0489c7;
    }

    .dop-pack-expand span {
        border-bottom: 1px solid #0489c7;
        position: relative;
        cursor: pointer;
    }

    .dop-pack-expand span::after {
        display: block;
        content: ' ';
        height: 5px;
        width: 10px;
        background-image: url('~@/assets/hometeacher/images/expand-down-blue.png');
        position: absolute;
        right: -15px;
        top: 7px;
    }

    .course-card__repeate {
        color: #0493c3;
        text-decoration: none;
        border-bottom: 1px solid;
        display: inline-block;
    }

    .course-card__repeate::after {
        content: " ➔";
        vertical-align: super;
        position: absolute;
        padding-left: 5px;
    }

    .course-result__description {
        font-size: 16px;
        line-height: 20px;
        color: #8b8496;
    }

    a.select-course-btn {
        text-align: center;
        display: inline-block;
        width: 180px;
        color: white;
        text-decoration: none;
        font-family: Manrope Bold;
        font-size: 18px;
        background-image: url(~@/assets/hometeacher/images/green-btn-bg.png);
        background-repeat: repeat-x;
        height: 45px;
        border-radius: 20px;
        text-decoration: none;
        box-shadow: 0px 1px 5px 0 rgba(40, 40, 40, 0.5);
        line-height: 41px;
        text-shadow: 1px 1px 1px rgb(53, 158, 33);
    }

    @media (max-width: 991.8px) {
        a.select-course-btn {
            width: 100%;
        }

        .course-card {
            border-top: 1px solid #d7e0e5;
            margin-bottom: 0;
            box-shadow: 2px 6px 7px #0000004a;
            border-left: none;
            border-bottom: none;
            border-right: none;
            border-radius: 0;
        }

        .img-fluid {
            max-width: 50%;
        }
    }
</style>

<style>
    .share-wrapper #share-network-list > a[class^="share-network-"] {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
        margin-right: 7px !important;
        border-radius: 5px;
    }

    .share-wrapper #share-network-list > a[class^="share-network-"] > i.fab {
        width: 30px;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
    }

    .share-wrapper #share-network-list {
        margin: 0 !important;
    }

    .statistic {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .statistic__item + .statistic__item {
        margin-top: 10px;
    }

    .statistic__item {
        font-size: 14px;
        color: #4f4d5c;
    }

    .statistic__item strong {
        font-family: "Manrope Bold";
        color: #231c37;
    }

    .progress-wrapper {
        padding-top: 0;
    }

    .progress {
        background-color: #e7eff2;
        border-radius: 5px;
        box-shadow: none;
    }

    .progress-bar.bg-default {
        background-color: #5bb947 !important;
    }

    .progress-info {
        margin-bottom: 0;
    }

    .progress-label span {
        background-color: transparent;
        color: inherit;
        font-size: .85rem;
        font-weight: normal;
        padding: 0;
        text-transform: none;
    }

    .progress-label strong {
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    }
</style>


<style src="@/assets/hometeacher/css/main.css"></style>
